import StudentRoundViewComponent from '@/components/showcase/student-round-view/student-round-view';
import StudentTreeChartComponent from '@/components/showcase/student-tree-chart/student-tree-chart';
import { appConfigService } from '@/providers/services/app/app-config';
import { sessionService } from '@/providers/services/auth/session';
import { Vue, Component } from 'vue-property-decorator';
import LearnerIdentity from '../learners/learner-identity/learner-identity';

@Component({
    name: 'showcase',
    components: {
        'learner-identity': LearnerIdentity,
        'student-tree-view': StudentTreeChartComponent,
        'student-round-view': StudentRoundViewComponent,
    },
})
export default class ShowCasePage extends Vue {

    // -----------------------------------------------------------
    // Properties

    private session = sessionService.getSession();

    private strongLearner: any = null;

    private weakLearner: any = null;

    private studentLearners: any = null;

    // -----------------------------------------------------------
    // Hooks

    private created() {
        this.loadConfigData();
    }


    // -----------------------------------------------------------
    // Methods


    private loadConfigData() {
        const session = this.session;
        const learnersList =  appConfigService.showcaseLearners();
        const strongLearner = learnersList.strongLearner;
        const weakLearner = learnersList.weakLearner;
        this.strongLearner = strongLearner[session!.user_id] || strongLearner.default;
        this.weakLearner = weakLearner[session!.user_id] || weakLearner.default;
        this.studentLearners = appConfigService.showcaseLearners();
    }


}
